import { WORK, TIMELINE, ONEWORK } from '../types';

const initialState = {
    hasWork: false,
    hasTimeLine: false,
    works: [],
    time: [],
    work: null
};

export default function(state = initialState, action){
    switch(action.type){
        case WORK:
            return { 
                hasWork: true,
                works: action.payload
            };
        case ONEWORK:
            return {
                hasWork: true,
                work: action.payload
            }
        case TIMELINE:
            console.log(action.payload)
            return {
                hasTime: true,
                time: action.payload
            };
        default:
            return state;
    }
}